import { Head, Link } from '@inertiajs/react';
import { MainLayout } from '../../layouts/MainLayout';
import { route } from '../../utils/route';

export default function Success() {
  return (
    <MainLayout>
      <Head>
        <title>Cuenta verificada | Abasto Virtual</title>
        <meta name="robots" content="noindex" />
      </Head>

      <div className="min-h-screen bg-gradient-to-br from-green-50 to-slate-50 pb-16 pt-10 md:pt-16">
        <div className="mx-auto max-w-[500px] px-4">
          <div className="mt-6 rounded-2xl bg-white p-8 text-center shadow-lg md:p-10">
            {/* Success icon with pop animation */}
            <div className="mx-auto mb-7 flex h-24 w-24 animate-[pop-in_0.6s_cubic-bezier(0.34,1.56,0.64,1)] items-center justify-center rounded-full bg-gradient-to-br from-green-500 to-green-600 md:h-[100px] md:w-[100px]">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                className="h-12 w-12 text-white md:h-[50px] md:w-[50px]"
              >
                <path
                  d="M20 6L9 17l-5-5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <h1 className="mb-3 text-[28px] font-bold text-green-800">
              ¡Cuenta verificada!
            </h1>
            <p className="mb-2 text-base leading-relaxed text-gray-600">
              Tu cuenta ha sido verificada exitosamente.
            </p>
            <p className="mb-8 text-sm text-gray-400">
              Ya podés disfrutar de todas las funciones de Abasto Virtual.
            </p>

            {/* Action buttons */}
            <div className="flex flex-col gap-3">
              <Link
                href={route('products.index')}
                className="inline-flex items-center justify-center gap-2.5 rounded-xl bg-green-500 px-7 py-3.5 text-base font-semibold text-white transition-all hover:-translate-y-0.5 hover:bg-green-600 hover:text-white hover:no-underline hover:shadow-lg hover:shadow-green-500/30"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  className="h-5 w-5"
                >
                  <circle cx="9" cy="21" r="1" />
                  <circle cx="20" cy="21" r="1" />
                  <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
                </svg>
                Ir al mercado
              </Link>
              <Link
                href={route('profile')}
                className="inline-flex items-center justify-center gap-2.5 rounded-xl border border-gray-300 bg-white px-7 py-3.5 text-base font-semibold text-gray-700 transition-all hover:bg-gray-50 hover:text-gray-700 hover:no-underline"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  className="h-5 w-5"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
                Ver mi perfil
              </Link>
            </div>

            <p className="mt-5 text-[13px] text-gray-400">
              Podés cerrar esta pestaña si lo preferís.
            </p>
          </div>
        </div>
      </div>

      {/* Custom animation keyframes */}
      <style>{`
        @keyframes pop-in {
          0% { transform: scale(0); }
          100% { transform: scale(1); }
        }
      `}</style>
    </MainLayout>
  );
}
